import _extends from '@babel/runtime/helpers/esm/extends';
import React from 'react';
import DSButton from '@elliemae/ds-basic/Button';
import { ModalFooter, ModalFooterActions } from '../blocks.js';
import '@babel/runtime/helpers/esm/defineProperty';
import '@elliemae/ds-classnames';

var Footer = function Footer(_ref) {
  var additionalFooterCssClass = _ref.additionalFooterCssClass,
      actionsRef = _ref.actionsRef,
      rejectLabel = _ref.rejectLabel,
      onReject = _ref.onReject,
      overridePropsRejectButton = _ref.overridePropsRejectButton,
      confirmLabel = _ref.confirmLabel,
      onConfirm = _ref.onConfirm,
      overridePropsConfirmButton = _ref.overridePropsConfirmButton,
      showRejectButton = _ref.showRejectButton;
  return /*#__PURE__*/React.createElement(ModalFooter, {
    classProps: {
      additionalFooterCssClass: additionalFooterCssClass
    },
    "data-testid": "modal-footer-wrapper"
  }, /*#__PURE__*/React.createElement(ModalFooterActions, {
    ref: actionsRef
  }, showRejectButton === true && /*#__PURE__*/React.createElement(DSButton, _extends({
    buttonType: "secondary",
    className: "action-reject",
    containerProps: {
      'data-testid': 'modal-footer-reject-btn'
    },
    labelText: rejectLabel,
    onClick: onReject
  }, overridePropsRejectButton)), /*#__PURE__*/React.createElement(DSButton, _extends({
    buttonType: "primary",
    className: "action-confirm",
    containerProps: {
      'data-testid': 'modal-footer-confirm-btn'
    },
    labelText: confirmLabel,
    onClick: onConfirm
  }, overridePropsConfirmButton))));
};

export default Footer;
export { Footer };
//# sourceMappingURL=Footer.js.map
